
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { useEffect, useRef, useState } from "react";
import { AppSettings } from "../../AppSettings";


export const useRunDicomSignalR = () => {
    //@ts-ignore
    const [connectionId, setConnectionId] = useState<string>();
    const [signalR, setSignalR] = useState<HubConnection>();

    const [dicomId, setDicomId] = useState<number | undefined>(undefined)
    const [dateTime, setDateTime] = useState<string | undefined>(undefined)
    
    const initialized = useRef(false)

    useEffect(() => {
        if (initialized.current && AppSettings.debug) {
            return;
        }

        initialized.current = true;

        let connection = new HubConnectionBuilder()
            .withUrl("/signal-r/dicom")
            .build();


        connection.on("Update", (data: number) => {
            setDicomId(data);
            setDateTime(new Date().toString());
        });

        //@ts-ignore
        const connecting = connection
            .start()
            .then(() => {
                setConnectionId(connection.connectionId ?? undefined);
            });

        setSignalR(connection);
    }, [setConnectionId, setSignalR, initialized, setDicomId, setDateTime]);

    useEffect(() => {
        return () => {
            signalR?.stop()
        }
    }, [signalR]);

    return {
        dicomId,
        dateTime
    }
}

export default useRunDicomSignalR;